export default __webpack_public_path__ + "static/media/dig-express.7c2509e2.svg";